import React, {Component} from 'react';
import TreeView from 'treeview-react-bootstrap';
import "./TreeViewMenu.css";
import axios from "axios";
import {BASE_URL, RESOURCE_BASE_URL} from "../../../../../configuration";
import ArticlesRow from "../../../../Admin/Articles/ViewAllArticles/ArticlesRow/ArticlesRow";
import {Link} from "react-router-dom";
import canvasDown from "../../../../../assets/img/canvasdown.png";
import canvasUp from "../../../../../assets/img/canvasup.png";
import $ from 'jquery';
import Collapsible from 'react-collapsible';

class TreeViewMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            articles: [],
            totalItemCount: 0,
            keys:[]


        };

        this.getArticles = this.getArticles.bind(this);
        this.groupArticlesByYear = this.groupArticlesByYear.bind(this);

    }

    groupArticlesByYear = (array, key) => {
        // Return the end result
        return array.reduce((result, currentValue) => {
            // If an array already present for key, push it to the array. Else create an array and push the object
            (result[currentValue[key]] = result[currentValue[key]] || []).push(
                currentValue
            );
            // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
            return result;
        }, {}); // empty object is the initial value for result object
    };

    getArticles = (offset, limit) => {
        limit = 1000;
        offset = 0;

        axios.get(RESOURCE_BASE_URL + 'api/articles/list')
            .then((res) => {
                console.log("dataaaaaaaaa ====> ", res.data);
                this.setState({
                    articles: res.data.articles,
                    totalItemCount: res.data.rowCount,
                    keys: res.data.keys

            })

    })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });

    };


    componentDidMount() {
        this.getArticles();

        var collapsed = true;

        setTimeout(() => {

            $('.btnCollapse').children('.minus').hide()

            $(".btnCollapse").click(function () {
                collapsed = !collapsed;
                if (collapsed) {
                    $(this).children('.minus').hide()
                    $(this).children('.plus').show()
                    $(this).parent().parent().children('.collapseContent').slideUp('slow');
                } else {

                    $(this).children('.plus').hide()
                    $(this).children('.minus').show()
                    $(this).parent().parent().children('.collapseContent').slideDown('slow');
                }
            });
        }, 100)

    }

    render() {

        return (
            <div className="tree-view-content ">

                <div className="tree-view-div no-padding no-margin collapse-light-green">
                    {/* {sortedArticles.map(articles => {
                        if (articles.createdOn.substring(0,4)==="2019"){
                            let item={
                                text:articles.title,
                                href:""
                            };
                            data[0].nodes.push(item);
                        }

                    })}*/}
                    <div className="responsive-userAddress-table-mobile ">
                        <div className="custom-col-10 text-center-responsive article-item-heading-resp">論文</div>
                        <div className="custom-col-1 float-right-plus btnCollapse">
                            <span className="plus"><img src={canvasDown} alt="" width='25px'/></span>
                            <span className="minus"><img src={canvasUp} alt="" width='25px'/></span>
                        </div>
                        <div className="custom-col-1"></div>

                    </div>
                    <div className="collapseContent">

                        { this.state.keys !== 0 ?

                            this.state.keys.map((key) => {
                                return (
                                    <Collapsible trigger={key}>
                                        <p>
                                            <ul>
                                                {
                                                    this.state.articles[key].map((article) => {
                                                        return  <a href={BASE_URL +'article/'+ article.id}> <li className="article-list-item">{article.title}</li></a>
                                                    })

                                                }
                                            </ul>
                                        </p>

                                    </Collapsible>
                                );
                            }) : 'no articles'
                        }


                    </div>
                    {/*<ul id="myUL">
                        <li><span className="">2019</span>
                            <ul className="nested">
                                {sortedArticles.map(articles => {
                                    return <li><Link to={"/article/"+articles.id} className="info-link">{articles.title}</Link></li>

                                })}

                            </ul>
                        </li>
                    </ul>*/}
                </div>
            </div>
        )
    }

}

export default TreeViewMenu;



// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/InformationNotice/ArticleItem/TreeViewMenu.js